"use strict";
/**
 * 判断是否支持 webp (异步方法)
 *
 * ### Example
 * ```
 * detectWebp(result => console.log(result));
 * ```
 */
Object.defineProperty(exports, "__esModule", { value: true });
var local_storage_1 = require("./local-storage");
var support;
function detectWebp(callback) {
    if (support === void 0) {
        var local = local_storage_1.LS.get('supportWebp');
        support = local === 'true' ? true : local === 'false' ? false : void 0;
    }
    if (support !== void 0) {
        return callback(support);
    }
    var img = new Image();
    img.onload = function () {
        support = img.width > 0 && img.height > 0;
        local_storage_1.LS.set('supportWebp', support);
        callback(support);
    };
    img.onerror = function () {
        support = false;
        local_storage_1.LS.set('supportWebp', support);
        callback(support);
    };
    img.src = 'data:image/webp;base64,UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==';
}
exports.detectWebp = detectWebp;
